var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#282B2F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1261_6144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5714 24.0002C22.4649 24.0002 24 22.4652 24 20.5716C24 18.6781 22.4649 17.1431 20.5714 17.1431C18.6778 17.1431 17.1428 18.6781 17.1428 20.5716C17.1428 22.4652 18.6778 24.0002 20.5714 24.0002Z",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 24.0002C33.8934 24.0002 35.4284 22.4652 35.4284 20.5716C35.4284 18.6781 33.8934 17.1431 31.9999 17.1431C30.1063 17.1431 28.5713 18.6781 28.5713 20.5716C28.5713 22.4652 30.1063 24.0002 31.9999 24.0002Z",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4286 24.0002C45.3221 24.0002 46.8571 22.4652 46.8571 20.5716C46.8571 18.6781 45.3221 17.1431 43.4286 17.1431C41.5351 17.1431 40 18.6781 40 20.5716C40 22.4652 41.5351 24.0002 43.4286 24.0002Z",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5714 35.4289C22.4649 35.4289 24 33.8939 24 32.0003C24 30.1068 22.4649 28.5718 20.5714 28.5718C18.6778 28.5718 17.1428 30.1068 17.1428 32.0003C17.1428 33.8939 18.6778 35.4289 20.5714 35.4289Z",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 35.4289C33.8934 35.4289 35.4284 33.8939 35.4284 32.0003C35.4284 30.1068 33.8934 28.5718 31.9999 28.5718C30.1063 28.5718 28.5713 30.1068 28.5713 32.0003C28.5713 33.8939 30.1063 35.4289 31.9999 35.4289Z",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4286 35.4289C45.3221 35.4289 46.8571 33.8939 46.8571 32.0003C46.8571 30.1068 45.3221 28.5718 43.4286 28.5718C41.5351 28.5718 40 30.1068 40 32.0003C40 33.8939 41.5351 35.4289 43.4286 35.4289Z",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5714 46.8571C22.4649 46.8571 24 45.3221 24 43.4286C24 41.5351 22.4649 40 20.5714 40C18.6778 40 17.1428 41.5351 17.1428 43.4286C17.1428 45.3221 18.6778 46.8571 20.5714 46.8571Z",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 46.8571C33.8934 46.8571 35.4284 45.3221 35.4284 43.4286C35.4284 41.5351 33.8934 40 31.9999 40C30.1063 40 28.5713 41.5351 28.5713 43.4286C28.5713 45.3221 30.1063 46.8571 31.9999 46.8571Z",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4286 46.8571C45.3221 46.8571 46.8571 45.3221 46.8571 43.4286C46.8571 41.5351 45.3221 40 43.4286 40C41.5351 40 40 41.5351 40 43.4286C40 45.3221 41.5351 46.8571 43.4286 46.8571Z",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9941 22.9946L29.577 29.5775",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9941 41.0063L29.577 34.4233",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4229 29.5775L41.0057 22.9946",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1261_6144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile1);
export default __webpack_public_path__ + "static/media/profile_1.e69f3c97802aa2c75584b3265f084f14.svg";
export { ForwardRef as ReactComponent };